import * as Sentry from '@sentry/angular';

import { environment } from '../../../environments/environment';

/**
 * Inicializa Sentry no boot da app — DEVE ser chamado antes de
 * `bootstrapApplication()` em main.ts.
 *
 * Sem `SENTRY_DSN` configurado: Sentry.init é chamado mas vira no-op
 * (não envia eventos). Isso é intencional — em dev local, ninguém precisa
 * provisionar Sentry só pra rodar a app.
 *
 * `browserTracingIntegration` automaticamente coleta Web Vitals padrão
 * (LCP, INP, CLS) como measurements em transactions de pageload. O
 * módulo `web-vitals.ts` adiciona breadcrumbs explícitos por metric pra
 * dar mais contexto em erros (ex: "LCP foi 4.2s antes do erro").
 */
export function initSentry(): void {
  const dsn = environment.sentryDsn;

  Sentry.init({
    dsn: dsn || undefined,
    enabled: !!dsn,
    environment: environment.production ? 'production' : 'development',
    release: environment.commitSha,

    integrations: [
      Sentry.browserTracingIntegration({
        // INP é Core Web Vital desde mar/2024 (substituiu FID).
        enableInp: true,
      }),
    ],

    // 10% sample rate de transactions em prod (alvo arch §6.2). Em dev,
    // 100% pra facilitar debug.
    tracesSampleRate: environment.production ? 0.1 : 1.0,

    // Ignorar erros conhecidos de extensions de browser.
    ignoreErrors: [
      'Non-Error promise rejection captured',
      'ResizeObserver loop',
    ],
  });
}
